import React, { useState } from 'react';
import { Input, InputAdornment, IconButton } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import './style.scss';

interface IPasswordInput {
	value: string;
	placeholder: string;
	hasError?: boolean | string;
	errorMsg?: string;
	width?: number;
	disabled?: boolean;
	name: string;
	onChange: (e: React.ChangeEvent<unknown>) => unknown;
	onBlur: (e: React.ChangeEvent<unknown>) => unknown;
}

export const PasswordInput: React.FC<IPasswordInput> = ({
	placeholder,
	hasError,
	errorMsg,
	disabled,
	...rest
}: IPasswordInput) => {
	const [showPassword, setShowPassword] = useState(false);

	const togglePasswordVisibility = () => {
		setShowPassword(!showPassword);
	};

	return (
		<div className="InputRoot">
			<Input
				{...rest}
				disabled={disabled}
				placeholder={placeholder}
				type={showPassword ? "text" : "password"}
				error={!!hasError}
				sx={{
					width: '300px',
					height: '40px',
					fontSize: '16px',
					color: '#8f8f8f',
					padding: '10px',
					border: 'none',
					'&:before': {
						border: 'none',
					},
					'&:after': {
						border: 'none',
					},
					'&:hover:not(.Mui-disabled):before': {
						border: 'none',
					},
					'& .MuiIconButton-root': {
						margin: 0,
						padding: 0,
						width: '40px !important',
						color: '#8f8f8f',
						backgroundColor: 'transparent !important',
						'&:hover': {
							backgroundColor: 'transparent !important',
						},
						'&:focus': {
							backgroundColor: 'transparent !important',
						},
						'&:active': {
							backgroundColor: 'transparent !important',
						}
					}
				}}
				endAdornment={
					<InputAdornment position="end">
						<IconButton
							aria-label={
								showPassword ? 'hide the password' : 'display the password'
							}
							onClick={togglePasswordVisibility}
							edge="end"
						>
							{showPassword ? <VisibilityOff /> : <Visibility />}
						</IconButton>
					</InputAdornment>
				}
			/>
			{hasError && <p className="InputErrorBox">{errorMsg}</p>}
		</div>
	);
};